import React from "react";
import { MPAStandardSwitch } from "../mpa-material-ui-widgets/mpa-material-ui-standard-switch";
import {
  labelableSelectedStyle,
  labelableUnselectedStyle
} from "../../style-helper";

export class MpaSwitch extends React.Component {
  constructor(props) {
    super(props);
    const { color, label, context, value, min, max } = props.meta.stack;
    this.state = {
      color,
      label,
      context,
      style: labelableUnselectedStyle(color),
      value,
      min,
      max
    };
  }

  componentWillUnmount() {
    const { socket } = this.props;
    socket.off("rx");
  }

  /* */
  componentDidMount() {
    const { socket, meta } = this.props;
    socket.on(`rx`, data => {
      if (data.name === meta.stack.name || data.stack === meta.stack.name) {
        switch (data.type) {
          case "TOUCH":
            let style;
            if (data.val) {
              style = labelableSelectedStyle(this.state.color);
            } else {
              style = labelableUnselectedStyle(this.state.color);
            }
            this.setState({ style });
            break;
          case "VALUE":
            if (data.val !== undefined && typeof data.val === "boolean") {
              this.setState({ value: data.val });
            }
            break;
          case "COLOR":
            this.setState({ color: data.val }, () =>
              this.setState({
                style: labelableUnselectedStyle(this.state.color)
              })
            );
            break;
          case "CONTEXT":
            if (data.val !== undefined && typeof data.val === "string") {
              this.setState({ context: data.val });
            }
            break;
          default:
            break;
          case "LABEL":
            if (data.val !== undefined && typeof data.val === "boolean") {
              this.setState({ label: data.val });
            }
            break;
        }
      }
    });
  }

  render() {
    const { meta } = this.props;
    return (
      <div className="labelable" style={this.state.style}>
        <div className="label widget-label">
          <label>{this.state.label}</label>
        </div>
        <div className="label context-label">
          <label>{this.state.context}</label>
        </div>
        <div className="other-widget">
          <MPAStandardSwitch
            key={meta.widget.name}
            assignedcolor={this.state.color}
            checked={this.state.value}
          />
        </div>
      </div>
    );
  }
}
